import { render, staticRenderFns } from "./MFA.html?vue&type=template&id=378bb465&scoped=true&"
import script from "./MFA.vue?vue&type=script&lang=ts&"
export * from "./MFA.vue?vue&type=script&lang=ts&"
import style0 from "./MFA.scss?vue&type=style&index=0&id=378bb465&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378bb465",
  null
  
)

export default component.exports